@if (vendor$ | async; as vendor) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: vendor }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: vendor }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <elder-basic-pane-layout class="flex">
      <elder-pane>
        <elder-pane-header>
          <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
          <elder-pane-actions>
            <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                <mat-icon>delete</mat-icon>
                <span>{{ 'actions.delete' | translate }}</span>
              </button>
            </mat-menu>
          </elder-pane-actions>
        </elder-pane-header>
        <elder-pane-content>
          <form #mainFrm="ngForm" class="flex layout-row gap-xl">
            <div class="flex layout-col">
              <!-- Identifications -->
              <elder-pane-subtitle>{{ 'context.identification' | translate }}</elder-pane-subtitle>
              <div class="layout-col gap-md">
                <!-- ID -->
                <mat-form-field class="flex">
                  <input
                    matInput
                    name="id"
                    #idModel="ngModel"
                    required
                    [disabled]="!creationMode"
                    placeholder="{{ 'context.id' | translate }}"
                    pattern="{{ idValidatorPattern }}"
                    [(ngModel)]="vendor.id"
                  />
                  <mat-error elderValidationError></mat-error>
                </mat-form-field>
                <!-- name input field -->
                <mat-form-field class="flex">
                  <input
                    matInput
                    name="name"
                    placeholder="{{ 'context.name' | translate }}"
                    [(ngModel)]="vendor.name"
                  />
                </mat-form-field>
              </div>
            </div>
          </form>
        </elder-pane-content>
      </elder-pane>
    </elder-basic-pane-layout>
  </div>
}

<ng-template #header let-vendor>
  @if (creationMode) {
    <span>
      {{ 'manufacturer.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'manufacturer.title' | translate" [subheader]="'ID: ' + vendor.id">
    </elder-header>
  }
</ng-template>
